module.exports = __webpack_public_path__ + "static/media/konkurs-info.e582d9aa.pdf";